import { NetworkSite } from "../models/site";
import axiosConfig from "./axiosConfig";

interface NetworkSiteListResponse {
  sites: (NetworkSite | null)[];
}

const getNetworkSiteList = async (
  authToken: string,
  orgId: string,
  onlyLinkedNetwork?: boolean,
  userOrgId?: string
): Promise<NetworkSiteListResponse> => {
  const queryArgs: string[] = [];
  if (userOrgId) {
    queryArgs.push(`userOrgId=${userOrgId}`);
  }
  if (onlyLinkedNetwork) {
    queryArgs.push("onlyLinkedNetwork=true");
  }
  const { data } = await axiosConfig.get(
    `/organisation/${orgId}/network_site${
      queryArgs.length > 0 ? `?${queryArgs.join("&")}` : ""
    }`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getNetworkSiteList;
